/* web/style.css "card" */
.head { display: flex; align-items: flex-start; gap: 12px; margin-bottom: 14px; }
.headText { flex: 1; min-width: 0; }
.head h2 { margin: 0; font-size: 21px; font-weight: 700; line-height: 1.2; letter-spacing: -.01em; }
.peekLine { color: var(--muted); font-size: 14px; margin-top: 4px; line-height: 1.35; }
.grabber { display: none; }
/* The peek's star only shows while the card is a peek (phone width); the full card has the big button. */
.peekStar { display: none; }
.alert { display: flex; align-items: center; gap: 6px; color: var(--danger); font-weight: 600; font-size: 14px; margin-bottom: 14px; }
.alert :global(.icon) { width: 18px; height: 18px; }
.image { margin-bottom: 18px; }
.rows { display: flex; flex-direction: column; gap: 14px; padding-bottom: 18px; margin-bottom: 18px; border-bottom: 1px solid var(--line-soft); }
.row { display: flex; gap: 12px; align-items: flex-start; }
.ic { width: 22px; display: flex; justify-content: center; flex: none; padding-top: 1px; }
.detail { color: var(--muted); font-size: 14px; }
.endUnknown { display: inline-block; margin-top: 4px; color: var(--danger); background: var(--danger-fill); border-radius: 999px; padding: 3px 10px; font-size: 13px; font-weight: 600; }
.tags { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 18px; padding-bottom: 18px; border-bottom: 1px solid var(--line-soft); }
.tag { font-size: 13px; padding: 5px 10px; border-radius: 999px; background: var(--surface); border: 1px solid var(--line); }
.mine { background: rgba(var(--starred-rgb), .18); border-color: var(--starred); color: var(--text); font-weight: 600; }
.desc { margin: 0 0 18px; line-height: 1.5; white-space: pre-line; }
.actions { display: flex; gap: 10px; margin-bottom: 10px; }
.source { display: inline-flex; align-items: center; gap: 3px; color: var(--text); text-decoration: underline; text-underline-offset: 2px; font-size: 14px; font-weight: 600; margin: 6px 0 8px; }
.source:hover { color: var(--ink); }
.source :global(.icon) { width: 15px; height: 15px; }

@media (max-width: 760px) {
  .grabber { display: block; width: 100%; height: 18px; margin: -10px 0 4px; border: 0; background: transparent; position: relative; touch-action: none; }
  .grabber::after { content: ""; position: absolute; left: 50%; top: 6px; width: 36px; height: 5px; margin-left: -18px; border-radius: 3px; background: var(--line); }
  .head { touch-action: none; cursor: pointer; }
  .card:not([data-full]) .full { visibility: hidden; }
  .card:not([data-full]) .peekStar { display: inline-block; }
}
